// app-celular-api.js — cliente del pop-up "Lleva SmartDx a tu celular" (#1686, fase 2a).
// Cubre R29, R30 — .claude/specs/1686-checklist-uso-celular/
//
// FUERA de `me/` en el backend a propósito (ver `user_api/urls.py`). Solo la propia cuenta: no lleva id.
// La fase 2b suma acá `pedirWhatsappAppCelular` cuando #1683 esté en la base.
import getClient from "./get-client";

const client = getClient();

export const ACCIONES_APP_CELULAR = ["ahora_no", "ya_la_tengo"];

export const accionAppCelular = (accion) => client.post("/api/user/app-celular/", { accion });
